import axios, { AxiosResponse } from 'axios';
import { BaseService } from './BaseService';
import { Campus, Widget } from './types/organization';
import qs from 'qs';

export * from './types/organization';

export default class OrganizationService extends BaseService {
    constructor() {
        super('content/organization');
    }

    async getCampuses(schoolId: string): Promise<Campus[]> {
        return axios({
            method: 'GET',
            url: this.getUrl(`campuses/${schoolId}`),
        }).then(res => res.data);
    }

    async getGlobalWidgets(): Promise<Widget[]> {
        return this.getWidgets(true, []);
    }

    async getSchoolWidgets(schoolIds: number[]): Promise<Widget[]> {
        return this.getWidgets(false, schoolIds);
    }

    async getWidgets(includeGlobal = false, schoolIds: number[] = []): Promise<Widget[]> {
        const params = {
            includeInactive: false,
            schoolIds: undefined as number[] | undefined | null,
            includeGlobal: includeGlobal,
        };

        if (schoolIds.length === 0) {
            params.schoolIds = null;
        } else {
            params.schoolIds = schoolIds;
        }

        return axios({
            method: 'GET',
            url: this.getUrl(`widgets`),
            params,
            paramsSerializer: params => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        }).then((result: AxiosResponse<Widget[]>) => result.data);
    }
}
